<template>
    <div v-if="ready && product != null" class="lazy-product-card flex flex-1">
        <product-card class="flex-1" :variants="product.variants" :title="product.name" :is-top="product.is_top" :description="product.introduction && product.introduction != '' ? product.introduction : product.description" :media="product.media" :link="`/product/${product.slug}`"></product-card>
    </div>
</template>

<script>
import lazyProduct from '@mixins/components/lazy-product';

export default {
    name: "Cards.LazyProductCard",

    mixins: [lazyProduct],
}
</script>